import { useState } from 'react'


const FrontPageNoisemeter = ({ isActiveWomensMode }) => {
    const [status, setStatus] = useState('idle'); // 'idle' | 'success' | 'error'

    // Configuración optimizada para iPhone/Móviles
    const audioConstraints = {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: false
    };

    const handlePreActivate = async () => {
        try {
            // 1. Solicitamos el micrófono con las constraints de iPhone
            const stream = await navigator.mediaDevices.getUserMedia({ audio: audioConstraints });
            
            // 2. Éxito: marcamos estado
            setStatus('success');
            
            // 3. Liberamos el stream inmediatamente para no gastar batería/recursos
            // El navegador ya guardó el permiso "Concedido" para este dominio.
            stream.getTracks().forEach(track => track.stop());

        } catch (error) {
            console.error("Permiso denegado o error de hardware", error);
            // Si cae aquí, es porque el usuario denegó o canceló.
            setStatus('error');
        }
    };

    return (
        <div className={`FrontPageNoisemeter__Fan ${isActiveWomensMode ? 'FrontPageNoisemeter__Fan--Female' : 'FrontPageNoisemeter__Fan--Male'}`}>
            <div className="FrontPageNoisemeter__Fan__Card">
                
                <p className="FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Text--Medium FrontPageNoisemeter__Fan__Element--SpaceUp">Ruidómetro</p>
                
                {/* ESTADO INICIAL */}
                {status === 'idle' && (
                    <>
                        <p className="FrontPageNoisemeter__Fan__Text--Center"><span className='FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Text--Highlight'>Activa tu micrófono ahora</span> para estar listo cuando inicie el juego.</p>
                        
                        <button className="FrontPageNoisemeter__Fan__Element--Center FrontPageNoisemeter__Fan__Button Btn__Adsl--Red" onClick={handlePreActivate}>
                            <i className="bi bi-mic-fill"></i> Activar micrófono ahora
                        </button>

                        <p className="FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--SpaceUp">Para participar, necesitamos medir tus gritos.</p>
                    </>
                )}

                {/* ESTADO ÉXITO */}
                {status === 'success' && (
                    <div className="">
                        <p className='FrontPageNoisemeter__Fan__Text--Success FrontPageNoisemeter__Fan__Text--Big FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--ZeroBottom'>
                            <i className="bi bi-check-circle-fill"></i>
                        </p>
                        <p className='FrontPageNoisemeter__Fan__Text--Success FrontPageNoisemeter__Fan__Text--Center'>¡Estás listo!</p>
                        <p className="FrontPageNoisemeter__Fan__Text--Center">Esperando a que inicie la dinámica...</p>
                        <p className='FrontPageNoisemeter__Fan__Text--Center'>No cierres esta pantalla</p>
                    </div>
                )}

                {/* ESTADO ERROR (Permiso denegado) */}
                {status === 'error' && (
                    <div className="FrontPageNoisemeter__Fan__Error">
                        <p className='FrontPageNoisemeter__Fan__Text--Danger FrontPageNoisemeter__Fan__Text--Big FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--ZeroBottom'>
                            <i className="bi bi-mic-mute-fill"></i>
                        </p>
                        <p className='FrontPageNoisemeter__Fan__Text--Center'>Permiso denegado</p>
                        
                        <p className='FrontPageNoisemeter__Fan__Text--Center'>
                            <span className='FrontPageNoisemeter__Fan__Text--Highlight'>Necesitamos acceso a tu micrófono</span> para jugar.
                        </p>
                        
                        {/* Botón para reintentar. Si el navegador lo bloqueó permanente, no abrirá el popup, 
                            pero el usuario debe saber que debe intentarlo o revisar su configuración */}
                        <button className="FrontPageNoisemeter__Fan__Element--Center FrontPageNoisemeter__Fan__Button Btn__Adsl--Red" onClick={handlePreActivate}>
                            <i className="bi bi-arrow-clockwise"></i> Intentar activar de nuevo
                        </button>

                        {/* Mensaje de ayuda vital para iOS/Android cuando bloquean permanentemente */}
                        <p className='FrontPageNoisemeter__Fan__Text--Center' style={{fontSize: '0.8rem', marginTop: '10px', opacity: 0.8}}>
                            Si no aparece el mensaje, toca el ícono de 🔒 o configuración en tu navegador y permite el micrófono.
                        </p>
                    </div>
                )}

            </div>
        </div>
    );
};

export { FrontPageNoisemeter };

















// Funcional
// const FrontPageNoisemeter = ({ isActiveWomensMode }) => {
//     const [status, setStatus] = useState('idle'); // 'idle' | 'success' | 'error'

//     const handlePreActivate = async () => {
//         try {
//             // 1. Solicitamos el micrófono solo para obtener el permiso del navegador
//             //const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//             const stream = await navigator.mediaDevices.getUserMedia({ audio: {
//                 echoCancellation: true,
//                 noiseSuppression: true,
//                 autoGainControl: false
//             } });
            
//             // 2. Si tenemos éxito, marcamos estado y liberamos el stream inmediatamente.
//             // El navegador recordará que este sitio ya tiene permiso para esta sesión.
//             setStatus('success');
            
//             // Opcional: Detener los tracks para no gastar batería en la espera, 
//             // ya que Noisemeter.js volverá a pedir el stream.
//             stream.getTracks().forEach(track => track.stop());

//         } catch (error) {
//             console.error("Permiso denegado", error);
//             setStatus('error');
//         }
//     };


//     return (
//         <div className={`FrontPageNoisemeter__Fan ${isActiveWomensMode ? 'FrontPageNoisemeter__Fan--Female' : 'FrontPageNoisemeter__Fan--Male'}`}>
//             <div className="FrontPageNoisemeter__Fan__Card">
                
//                 <p className="FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Text--Medium FrontPageNoisemeter__Fan__Element--SpaceUp">Ruidómetro</p>
                
//                 {status === 'idle' && (
//                     <>
//                         <p className="FrontPageNoisemeter__Fan__Text--Center"><span className='FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Text--Highlight'>Activa tu micrófono ahora</span> para estar listo cuando inicie el juego.</p>
//                         <button className="FrontPageNoisemeter__Fan__Element--Center FrontPageNoisemeter__Fan__Button Btn__Adsl--Red" onClick={handlePreActivate}>
//                             <i className="bi bi-mic-fill"></i> Activar micrófono ahora
//                         </button>

//                         <p className="FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--SpaceUp">Para participar, necesitamos medir tus gritos.</p>
//                     </>
//                 )}

//                 {status === 'success' && (
//                     <div className="">
//                         <p className='FrontPageNoisemeter__Fan__Text--Success FrontPageNoisemeter__Fan__Text--Big FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--ZeroBottom'>
//                             <i className="bi bi-check-circle-fill"></i>
//                         </p>
//                         <p className='FrontPageNoisemeter__Fan__Text--Success FrontPageNoisemeter__Fan__Text--Center'>¡Estás listo!</p>
//                         <p className="FrontPageNoisemeter__Fan__Text--Center">Esperando a que inicie la dinámica...</p>
//                         <p className='FrontPageNoisemeter__Fan__Text--Center'>No cierres esta pantalla</p>
//                     </div>
//                 )}

//                 {status === 'error' && (
//                     <div className="FrontPageNoisemeter__Fan__Error">
//                         <p className='FrontPageNoisemeter__Fan__Text--Danger FrontPageNoisemeter__Fan__Text--Big FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--ZeroBottom'>
//                             <i className="bi bi-mic-mute-fill"></i>
//                         </p>
//                         <p className='FrontPageNoisemeter__Fan__Text--Center'>Permiso denegado</p>
//                         <p className='FrontPageNoisemeter__Fan__Text--Center'><span className='FrontPageNoisemeter__Fan__Text--Highlight'>Activa y habilita el permiso de tu micrófono</span> para poder jugar</p>
//                         <button className="FrontPageNoisemeter__Fan__Element--Center FrontPageNoisemeter__Fan__Button Btn__Adsl--Red" onClick={handlePreActivate}>
//                             <i className="bi bi-mic-fill"></i> Activar micrófono ahora
//                         </button>
//                     </div>
//                 )}

//             </div>
//         </div>
//     );
// };

// export { FrontPageNoisemeter };






// <div className="Wait">
//     <h1 className="Wait__Title">¡Prepárate!</h1>
//     <p className="Wait__Text">Estamos por comenzar la dinámica</p>
//     <p className="Welcome__Icon"><i className="bi bi-controller"></i></p>
//     {/* <p className="Welcome__Icon"><i class="bi bi-file-play"></i></p> */}
//     <p className="Welcome__Text">Aparecerá de manera automática</p>
//     <p className="Welcome__Text Welcome__Text--Highlight"><i className="bi bi-exclamation-triangle"></i> Permanece en la página</p>
// </div>